<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="$t('view-Payments.title')"
        :subtitle="$t('view-Payments.title.subtitle')"
        :text="$t('view-Payments.title.text')"
      />
      <div class="row">
        <div class="col-20">
          <transition
            name="fade"
            @before-leave="makeAbsolute"
          >
            <router-view
              :key="$route.params.id"
              :loader="loader"
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loader: true
    }
  },
  beforeMount () {
    this.$store.dispatch('payments/getList')
      .then(() => {
        this.loader = false
      }).catch((e) => {
        this.loader = false
      })
  }
}
</script>
